"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./Footer.style.css");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Footer() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "bottom",
    id: "bottom",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "text copyright",
      children: ["Copyright \xA9 2010 - ", new Date().getFullYear(), " by Consumer Intelligence Group"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
      className: "link privacy-link",
      target: "_blank",
      rel: "noreferrer",
      href: "https://consumerig.com/privacy-policy/",
      children: "View Privacy Policy"
    })]
  });
}

var _default = Footer;
exports.default = _default;